export const LOG_LEVEL = {
  INFO: "INFO",
  ERROR: "ERROR",
  WARN: "WARN",
  DEBUG: "DEBUG",
  TRACE: "TRACE",
};
